import React from 'react';

import { useSearch } from '../../../hooks/context';

const namespace = 'ui-best-seller-header';

/**
 * @typedef {Object} HeaderProps
 * @property {string} title - El título del encabezado.
 */

/**
 * Componente que renderiza el encabezado de "Best Seller".
 *
 * @returns {React.ReactNode|null} Un nodo React que contiene el encabezado de "Best Seller" o `null` si no hay datos disponibles.
 */
const BestSellerHeader = () => {
  const { header } = useSearch();

  if (!header) {
    return null;
  }

  const { title } = header;

  return (
    <div className={`${namespace}-title-container ${namespace}-desktop-title-container`}>
      <h1 className={`${namespace}-title ${namespace}-desktop-title`}>{title}</h1>
    </div>
  );
};

export default BestSellerHeader;
